import {
  useTranslate, TextField, EditButton, DeleteButton, CreateButton, TopToolbar,
  SimpleForm, required, Toolbar,
  SaveButton, BooleanInput,
  useRecordContext,
  Button,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { ListLive } from '@react-admin/ra-realtime';
import { Datagrid, IfCanAccess } from '@react-admin/ra-rbac';
import SearchFields from '../components/fields/Filters';
import { LIST_DEBOUNCE } from '../../../config';
import { TimeGranularityField } from '../../../components/fields/TimeGranularityField';
import { CreateWithSuccess } from '../../../components/baseForms/CreateWithSuccess';
import { EditWithSuccess } from '../../../components/baseForms/EditWithSuccess';
import { CreateToolbarRight } from '../../../components/CustomToolBar';
import { GrayTimeGranularityInputWithUpperLabel } from '../components/inputs/GrayTimeGranularityInputWithUpperLabel';
import { GrayTextInputWithUpperLabel } from '../components/inputs/GrayTextInputWithUpperLabel';

export const CertificationList = () => {

  const translate = useTranslate();
  return (
    <>
      <h3>{translate('resources.certification_categories.title')}</h3>
      <ListLive
        filters={SearchFields} debounce={LIST_DEBOUNCE} title="resources.certification_categories.title" actions={<TopToolbar><CreateButton/></TopToolbar>}>
        <Datagrid rowClick={false} bulkActionButtons={false}>
          <TextField source="name" label="general.fields.name"/>
          <TimeGranularityField source="validityPeriod" label="resources.certification_categories.fields.validity_period"/>
          <TextField source="description" label="general.fields.description"/>
          <IfCanAccess action="edit">
            <EditButton/>
          </IfCanAccess>
          <IfCanAccess action="delete">
            <DeleteButton/>
          </IfCanAccess>
        </Datagrid>
      </ListLive>
    </>
  );

};
const CertificationFields = () => {

  return (
    <>
      <GrayTextInputWithUpperLabel source="name" validate={required()} label="general.fields.name"/>
      <GrayTimeGranularityInputWithUpperLabel label={'resources.certification_categories.fields.validity_period'} source="validityPeriod"/>
      <BooleanInput source="isCertificationHolderNotified" label="resources.certification_categories.fields.is_certification_holder_notified"/>
      <BooleanInput source="isDocumentaryProofRequired" label="resources.certification_categories.fields.is_documentary_proof_required"/>
      <GrayTextInputWithUpperLabel source="description" label="general.fields.description" multiline rows={4}/>
    </>
  );

};

const CertificationEditHeading = () => {

  const record = useRecordContext();
  const translate = useTranslate();

  return (
    <h4 style={{ marginBottom: '10px' }}>{translate('general.text.edit')} {'"'}{record?.name}{'"'}</h4>
  );

};

export const CertificationCreate = () => {

  const translate = useTranslate();

  return (
    <CreateWithSuccess title="resources.certification_categories.title">
      <SimpleForm toolbar={<CreateToolbarRight narrow/>} sx={{ maxWidth: '1000px' }}>
        <h4>{translate('resources.certification_categories.text.create_title')}</h4>
        <Typography variant="body1">{translate('resources.certification_categories.text.category_explanation')}</Typography>
        <hr/>
        <CertificationFields/>
      </SimpleForm>
    </CreateWithSuccess>
  );

};

export const CertificationEdit = () => {

  const navigate = useNavigate();

  return (
    <EditWithSuccess title="resources.certification_categories.title" actions={false}>
      <SimpleForm toolbar={
        <Toolbar sx={{ justifyContent: 'end' }}>
          <Button label="ra.action.back" onClick={() => navigate(-1)} size="medium" sx={{ marginRight: '10px' }} variant="text"/>
          <SaveButton sx={{ ml: '8px' }}/>
        </Toolbar>}
      sx={{ maxWidth: '1000px' }}>
        <CertificationEditHeading/>
        <CertificationFields/>
      </SimpleForm>
    </EditWithSuccess>
  );

};
